/**
 * Collection cards: slide transition + PDP link dengan ?variant= saat hover/klik swatch
 * (data-variant-id dari metaobject field Variant).
 */
(function () {
  function buildProductUrlWithVariant(base, variantId) {
    if (!base) return '';
    if (!variantId) return base;
    try {
      var u = new URL(base, window.location.origin);
      u.searchParams.set('variant', String(variantId));
      return u.pathname + u.search + (u.hash || '');
    } catch (err) {
      var sep = base.indexOf('?') >= 0 ? '&' : '?';
      var withoutHash = base.split('#')[0];
      return withoutHash + sep + 'variant=' + encodeURIComponent(String(variantId));
    }
  }

  function loadLayer(layer, src, srcset, cb) {
    if (!src) {
      cb();
      return;
    }
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      cb();
    }
    function onLoad() {
      layer.removeEventListener('load', onLoad);
      finish();
    }
    layer.addEventListener('load', onLoad);
    layer.src = src;
    if (srcset) {
      layer.setAttribute('srcset', srcset);
    } else {
      layer.removeAttribute('srcset');
    }
    if (layer.complete) {
      layer.removeEventListener('load', onLoad);
      requestAnimationFrame(finish);
    }
  }

  function revealAfterPaint(wrapper) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        wrapper.classList.remove('is-swatch-reenter');
      });
    });
  }

  function swapSwatchWithSlide(wrapper, layer, src, srcset) {
    if (!src) return;
    var probe = new Image();
    probe.onload = function () {
      var revealed = false;
      function revealOnce() {
        if (revealed) return;
        revealed = true;
        revealAfterPaint(wrapper);
      }

      wrapper.classList.add('is-swatch-reenter');

      function onLayerLoad() {
        layer.removeEventListener('load', onLayerLoad);
        revealOnce();
      }

      layer.addEventListener('load', onLayerLoad);
      layer.src = src;
      if (srcset) {
        layer.setAttribute('srcset', srcset);
      } else {
        layer.removeAttribute('srcset');
      }

      if (layer.complete && layer.naturalWidth) {
        layer.removeEventListener('load', onLayerLoad);
        revealOnce();
      }
    };
    probe.onerror = function () {
      loadLayer(layer, src, srcset, function () {});
    };
    probe.src = src;
  }

  function bindMediaLink(mediaLink) {
    if (mediaLink.dataset.colorSwatchBound === '1') return;
    mediaLink.dataset.colorSwatchBound = '1';

    var wrapper = mediaLink.querySelector('.product-thumbnail__image-wrapper');
    var layer = mediaLink.querySelector('[data-color-swatch-layer]');
    if (!wrapper || !layer) return;

    var card = mediaLink.closest('.product-thumbnail');
    var baseUrl =
      (card && card.getAttribute('data-base-product-url')) || mediaLink.getAttribute('href') || '';
    var infoLink = card && card.querySelector('a.product-thumbnail__link--info');
    var swatchButtons = mediaLink.querySelectorAll('[data-color-swatch]');

    function setLinksForVariant(variantId) {
      var url = variantId ? buildProductUrlWithVariant(baseUrl, variantId) : baseUrl;
      mediaLink.setAttribute('href', url);
      if (infoLink) infoLink.setAttribute('href', url);
    }

    function resetLinks() {
      mediaLink.setAttribute('href', baseUrl);
      if (infoLink) infoLink.setAttribute('href', baseUrl);
    }

    function setActiveSwatch(activeBtn) {
      swatchButtons.forEach(function (btn) {
        if (btn === activeBtn) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
    }

    swatchButtons.forEach(function (btn) {
      function applyPreview() {
        var src = btn.dataset.previewSrc;
        var srcset = btn.dataset.previewSrcset || '';
        var vid = btn.dataset.variantId;
        setActiveSwatch(btn);

        if (vid) {
          setLinksForVariant(vid);
        } else {
          resetLinks();
        }

        if (wrapper.classList.contains('is-showing-swatch-preview')) {
          swapSwatchWithSlide(wrapper, layer, src, srcset);
        } else {
          loadLayer(layer, src, srcset, function () {
            wrapper.classList.add('is-showing-swatch-preview');
          });
        }
      }

      function goToPdpForSwatch(e) {
        e.preventDefault();
        e.stopPropagation();
        var vid = btn.dataset.variantId;
        window.location.href = vid ? buildProductUrlWithVariant(baseUrl, vid) : baseUrl;
      }

      btn.addEventListener('mouseenter', applyPreview);
      btn.addEventListener('focus', applyPreview);
      btn.addEventListener('click', goToPdpForSwatch);
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          goToPdpForSwatch(e);
        }
      });
    });

    function resetPreviewAndLinks() {
      wrapper.classList.remove('is-showing-swatch-preview');
      wrapper.classList.remove('is-swatch-reenter');
      swatchButtons.forEach(function (btn) {
        btn.classList.remove('is-active');
      });
      resetLinks();
    }

    if (card) {
      card.addEventListener('mouseleave', function (e) {
        if (e.relatedTarget && card.contains(e.relatedTarget)) return;
        resetPreviewAndLinks();
      });
      card.addEventListener('focusout', function () {
        setTimeout(function () {
          if (card.contains(document.activeElement)) return;
          resetPreviewAndLinks();
        }, 0);
      });
    } else {
      mediaLink.addEventListener('mouseleave', resetPreviewAndLinks);
    }
  }

  function scan() {
    document
      .querySelectorAll('.product-thumbnail--has-color-swatches a.product-thumbnail__link--media')
      .forEach(bindMediaLink);
  }

  window.initProductThumbnailSwatches = scan;
  document.addEventListener('product-thumbnails:updated', scan);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
